
export enum PaymentStatusExternalCd {
	CHECK_CASHED = 'CheckCashed',
	DECLINED = 'Declined',
	NO_PAYMENT_STATUS = 'NoPaymentStatus',
	PAYMENT_ISSUED = 'PaymentIssued',
	PAYMENT_PROCESSING = 'PaymentProcessing'}

